// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fRL5T.ui.label{background-color:#35cdc640;color:#005c58;cursor:default}:root[data-darkreader-scheme=dark] .fRL5T.ui.label{color:var(--anchore-color-gray-750)}.fRL5T.ui.label.mC2fI{padding:.4rem .5rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `fRL5T`,
	"compact": `mC2fI`
};
module.exports = ___CSS_LOADER_EXPORT___;
